import PageTitle from "../components/ui/PageTitle";

const PrivacyItem = ({ titles, descriptions, listItems }) => {
  return (
    <div>
      {titles.map((title, index) => (
        <div className="content-item w-full mb-10" key={index}>
          {index === 1 ? (
            <div>
              <h2 className="text-[18px] font-medium text-qblack mb-5">
                {index + 1}. {title}
              </h2>
              <p className="text-[15px] text-qgraytwo leading-7 mb-5">
                {descriptions[index]}
              </p>
              <ul className="list-disc ml-5">
                {listItems.map((item, listItemIndex) => (
                  <li
                    key={listItemIndex}
                    className={
                      listItemIndex === listItems.length - 1
                        ? "text-[15px] text-qgraytwo leading-7 mb-5"
                        : "text-[15px] text-qgraytwo leading-7"
                    }
                  >
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-[15px] text-qgraytwo leading-7 mb-10">
                We maintain backups of the website including your data for
                maintenance purposes. Modified or deleted data will eventually
                roll off these backups.
              </p>
            </div>
          ) : (
            <>
              <h2 className="text-[18px] font-medium text-qblack mb-5">
                {index + 1}. {title}
              </h2>
              <p className="text-[15px] text-qgraytwo leading-7">
                {descriptions[index]}
              </p>
              {index === titles.length - 1 && (
                <a href="/contact">
                  <span className="text-[#9A9A9A] text-[15px] hover:text-qblack border-b border-transparent hover:border-qblack cursor-pointer capitalize">
                    Contact form
                  </span>
                </a>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default function Privacy() {
  const titles = [
    "Information Collection, Use, and Sharing",
    "Your Access to and Control Over Information",
    "Registration",
    "Security",
    "Cookies",
    "Links",
    "Notification of Changes",
    "Additional Concerns",
  ];
  const descriptions = [
    "We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us. We will not sell or rent this information to anyone. We will use your information to contact you. We will not share your information with any third party outside of our organization. Depending on your subscription choices, we may contact you via email in the future to tell you about updates to the website, or changes to this privacy policy. Upon certain additional positive actions on your part (e.g. posting a review) some of your information (e.g. your name) may be published on the website. You will be notified of this whenever you take such positive actions.",
    "You may opt out of any future contacts from us at any time. You can do the following at any time by visiting your profile on our website:",
    "In order to use this website, you must first complete the registration form. During registration you are required to give your name and email address. At your option, you may also provide other information about yourself (such as your interests), but it is not required.",
    "We take precautions to protect your information. When you submit information via the website, your information is protected both online and offline. Browser connections to the website are encrypted and information is transmitted to us via SSL. You can verify this by looking for a closed lock icon at the bottom of your web browser, or looking for https at the beginning of the address of the web page. While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only users who need the information to perform a specific task are granted access to personally identifiable information. The computers/servers on which we store personally identifiable information are kept in a secure environment.",
    "We use cookies on this site. A cookie is a piece of data stored on a site visitor's computer to help us improve your access to our website and to identify you when you return to our website. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance their experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.",
    "This web site contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.",
    "You will be notified by email whenever material changes are made to this privacy policy.",
    "If you feel that we are not abiding by this privacy policy, or if you have any questions about it, you should contact us immediately via the",
  ];
  const listItems = [
    "See what data we have about you.",
    "Modify or delete any data we have about you.",
    "Delete your account.",
  ];

  return (
    <>
      <div className="terms-condition-page w-full pb-[30px]">
        <div className="w-full mb-[30px]">
          <PageTitle
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Privacy Policy", path: "privacy-policy" },
            ]}
            title="Privacy Policy"
          />
        </div>
        <div className="w-full">
          <div className="container-x mx-auto">
            <PrivacyItem
              titles={titles}
              descriptions={descriptions}
              listItems={listItems}
            />
          </div>
        </div>
      </div>
    </>
  );
}
